import React from "react";
import classnames from "classnames";

import "./index.less";

// 正方形
export const SkeletonSquare = ({ className }) => {
  return <div className={classnames("skeleton-square", className)} />;
};

// 圆形
export const SkeletonRound = ({ className }) => (
  <div className={classnames("skeleton-round", className)} />
);

// 长方形
export const SkeletonRectangle = ({ className }) => (
  <div className={classnames("skeleton-rectangle", className)} />
);
